export default {
  pending: 'pending',
  fulfilled: 'fulfilled',
  canceled: 'canceled',
  pendingCreditCard: 'pendingCreditCard',
}
